// Google Analytics utility functions
// Get GA4 Measurement ID from environment variable or use default
const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID || 'G-B1ME60QNM9';

/**
 * Track a custom event
 * @param {string} eventName - Name of the event
 * @param {object} eventParams - Additional parameters for the event
 */
export const trackEvent = (eventName, eventParams = {}) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, eventParams);
  }
};

/**
 * Track page view
 * @param {string} pagePath - Path of the page
 * @param {string} pageTitle - Title of the page
 */
export const trackPageView = (pagePath, pageTitle) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: pagePath,
      page_title: pageTitle,
    });
  }
};

/**
 * Track user engagement events
 */
export const analytics = {
  // Track when user starts calculator
  trackCalculatorStart: () => {
    trackEvent('calculator_start', {
      event_category: 'Calculator',
      event_label: 'User started GPA calculation',
    });
  },

  // Track when user enters number of courses
  trackCoursesEntered: (numCourses) => {
    trackEvent('courses_entered', {
      event_category: 'Calculator',
      event_label: 'Number of courses',
      value: numCourses,
    });
  },

  // Track when user calculates GPA
  trackGPACalculated: (gpa, numCourses) => {
    trackEvent('gpa_calculated', {
      event_category: 'Calculator',
      event_label: 'GPA Calculation Complete',
      value: parseFloat(gpa),
      num_courses: numCourses,
    });
  },

  // Track button clicks
  trackButtonClick: (buttonName) => {
    trackEvent('button_click', {
      event_category: 'Interaction',
      event_label: buttonName,
    });
  },
};

